import React from "react";
import Button from "reactstrap/lib/Button";
import Form from "reactstrap/lib/Form";
import Swal from "sweetalert2";
import {Toast} from "../../../../utils/sweetAlert";
import * as AXIOS from "../../../../services/usersService";
import {t} from "react-switch-lang";

const DeactivateClient = props => {
    const handleSubmit = async event => {
        event.preventDefault();
        await AXIOS.deactivateUser(props.data.id)
            .then(r => {
                Toast.fire({
                    icon: "success",
                    title: `${
                        props.data.activated
                            ? t("message.successDeactivate")
                            : t("message.successActivate")
                    }`
                });
                props.setRowChanged();
                props.toggleModal();
            })
            .catch(r => {
                Swal.fire({
                    text: `${t("message.errorApi")}`,
                    icon: "error",
                    confirmButtonText: "OK"
                });
            });
    };
    return (
        <Form
            onSubmit={e => handleSubmit(e)}
            noValidate
            className="d-flex justify-content-between"
        >
            <Button className="primary deleteButton">
                {props.data.activated
                    ? t("buttons.deactivateBtn")
                    : t("buttons.activateBtn")}{" "}
            </Button>
        </Form>
    );
};

export default DeactivateClient;
